import { render, staticRenderFns } from "./ElectronicBilling.vue?vue&type=template&id=e051cfd8&scoped=true"
import script from "./ElectronicBilling.vue?vue&type=script&lang=js"
export * from "./ElectronicBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e051cfd8",
  null
  
)

export default component.exports